<template>
    <div>
        <div>
			<div  v-show="$root.showSlinkAvail && (az.noSlash($route.path) == '' || az.noSlash($route.path) == '/get')" class="searchResults  showSlink has-text-centered">
				
				<div class="sweet"><b>Yes!</b></div><br>
				<div class="bandSearch top10">
					The slink <span class="has-text-weight-bold">"{{$root.slink}}"</span> is available, would you like to get it?
				</div>
				<div class="top20">
					<button class="button  is-turk" @click.prevent="addIt"><b>ADD TO CART</b></button>
					<button class="button  is-light" @click.prevent="cancel"><b>NO THANKS</b></button>
				</div>
				<div class="is-size-4">Don't let someone else beat you to it!</div>
			</div>
		</div>

		<div v-show="$root.showSubs" class="showSlink has-text-centered searchResults ">
			<div class="sweet"><b>sorry <span class="has-text-turk">...</span></b></div>
				<div class="is-size-4 top20 limitWidth marginAutod leftTurkBorder subSlinksShowingText">
					<b>The subslink you entered does not exist, but the following slink and subslinks do:</b>
					<br>Click on one to visit it
				</div>
		
				<div class="band top20">
					<ul>
						<li class="is-size-5 has-text-weight-bold"><a :href="$root.apiUrl + $root.slinkForSubOptions" class="has-text-white">{{$root.slinkForSubOptions}}</a></li>
						<li class="is-size-5 has-text-weight-bold" v-for="(item, itemKey) in $root.subOptions" :key="itemKey"><a :href="$root.apiUrl + $root.slinkForSubOptions + ':' + item" class="has-text-warning">{{$root.slinkForSubOptions}}:{{item}}</a></li>
					</ul>
				</div>
				<br>
				<button class="button  top20 is-warning" @click.prevent="$root.showSubs = false"><b>Done</b></button>
				<br>
		</div>
    </div>

</template>

<script>

import constants from '../STATIC/constants'

export default{

    data: function(){
        return {
            az: az,
            constants: constants
        }
    },

	methods: {
		addIt: function(){
			this.$root.addToCart('slink', this.$root.slink, constants.SLINK_YEARLY_PLAN.plan); 
			this.$root.showSlinkAvail = false; 
			window.scrollTo(0,0)
		},

		cancel: function(){
			this.$root.showSlinkAvail = false
		},

		tryIt: function(){
			this.$root.showSlinkAvail = false
			this.$router.push('/try?s=' + this.$root.slink)
		}

		/* <button class="button is-small is-warning" @click="$root.addToCart('slink', $root.slink, constants.SLINK_YEARLY_PLAN.plan); $root.showSlinkAvail = false"><b>ADD TO CART</b></button> */
	}


}

</script>


// WEBPACK FOOTER //
// src/components/SearchResults.vue